import { render, staticRenderFns } from "./DepartmentNotificationsInput.vue?vue&type=template&id=5ec7666b"
import script from "./DepartmentNotificationsInput.vue?vue&type=script&lang=js"
export * from "./DepartmentNotificationsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports